
/******************************/
/*       Vue Store       */
/******************************/

const newCourse = {
  sens: '',
  date: '',
  heure: '',
  nbrPassagers: 0,
  nbrBagages: -1,
  skis: '',
  nbrSkis: -1,
  pickup: {
    ville: '',
    type: '',
    complement: {}
  },
  dropoff: {
    ville: '',
    type: '',
    complement: {}
  },
  tarif: '',
  duree: '',
  prestation: '', // [basic|luxury]
  autoroute: null,
};
var places = [];

function getVilleByCode(code){
  var ville = '';
  //Object.values(store.state.places).forEach(function(type){
  Object.values(places).forEach(function(type){

    type.forEach(function(place){

      if(place.code == code){
        ville = place.nom;
      }

      if(place.secteurs){
        place.secteurs.forEach(function(secteur){
          if(secteur.code == code){
            ville = place.nom + ' - ' + secteur.nom;
          }
        });
      }

    });
  });

  return ville!='' ? ville : code;
}
function getCourseStatus(course){
  if(
    course.sens == '' &&
    course.date == '' &&
    course.nbrPassagers == 0 &&
    course.nbrBagages == -1 &&
    course.pickup.ville == '' &&
    course.dropoff.ville == ''
  ){
    return 'empty';

  }else if (
    course.sens != '' &&
    course.date != '' &&
    course.nbrPassagers > 0 &&
    course.nbrBagages > -1 &&
    course.pickup.ville != '' &&
    course.dropoff.ville != ''
  ) {
    return 'complete';

  }else{
    return 'pending';

  }
}
function getTarifByCode(code){
  var tarifCode = '';
  //Object.values(store.state.places).forEach(function(type){
  Object.values(places).forEach(function(type){

    type.forEach(function(place){

      if(place.code == code){
        tarifCode = place.tarif;
      }

      if(place.secteurs){
        place.secteurs.forEach(function(secteur){
          if(secteur.code == code){
            tarifCode = secteur.tarif;
          }
        });
      }

    });
  });

  return tarifCode;

}
function getNbrBagagesTexte(count){
  if(count < 1){
    return t('Aucun bagage');
  }else if(count == 1){
    return t('1 bagage')
  }else if(count > 4){
    return t('5 bagages et +').replace('%count',count);
  }else{
    return t('%count bagages').replace('%count',count);
  }
}
function getSkisTexte(value, count=0){
  var ret = '';
  switch(value){
    case 'oui':
      ret = t('Avec skis');
      if(count > 0) {
        let countLabel = count == 5 ? t('5 et +') : count;
        ret+= ' (' + countLabel + ')';
      }
      break;
    case 'non':
      ret = t('Sans skis');
      break;
  }
  return ret;
}
function getPrestationTexte(prestation){
  return prestation == 'luxury' ? 'NK Luxury' : 'NK Basic';;
}
function prepareRequest(trajet, index){
  var station = trajet.sens=='sv' ? trajet.pickup.ville : trajet.dropoff.ville;
  station = getTarifByCode(station);
  var vallee = trajet.sens=='vs' ? trajet.pickup.ville : trajet.dropoff.ville;
  vallee = getTarifByCode(vallee);
  var passagers = trajet.nbrPassagers;
  var date = trajet.date.replace('-','_').replace('-','_');
  var heure = trajet.heure.replace(':','_');
  var retour = index==0 ? 'to' : 'back';
  var sens = trajet.sens;
  var transport = trajet.sens=='vs' ? trajet.pickup.type : trajet.dropoff.type;

  var req = station+'-'+vallee+'-'+passagers+'-'+date+'-'+heure+'-'+retour+'-'+sens+'-'+transport;

  return req;
}
function prepareFullRequest(trajet, index){
  var req = prepareRequest(trajet, index);
  req+= '-' + trajet.prestation;

  return req;
}

/******************************/
/*       Vue Components       */
/******************************/

// ATOMS

/*
 *  <bouton size="large" v-on:click="foo">Click me</bouton>
 */
Vue.component('bouton', {
  props: [
    'size',
    'disabled'
  ],
  computed: {
    btnClass: function(){
      switch (this.size) {
        case 'large':
        case 'small':
        case 'flat':
          var classe = `btn-${this.size}`;
          break;
        default:
          var classe = 'btn';
          break;
      }

      classe+= this.disabled ? ' disabled' : '';

      return classe;
    },
  },
  template: `<span><button class="waves-effect waves-light" :class="btnClass" v-on:click="$emit('click')"><slot> </slot></button>{{' '}}</span>`
});
/*
 *  <text-input id="input_1" icon="phone" type="text" required description="Helper text" v-on:change="test">Label</text-input>
 */
Vue.component('text-input', {
  props: {
    id: String,
    icon: String, // See : https://materializecss.com/icons.html
    type: String,
    required: Boolean,
    description: String,
    picker: String,
    minDate: String,
  },
  data: function(){
    return {
      value: ''
    }
  },
  computed: {
    labels: function(){
      return{
        requis: t('requis')
      }
    }
  },
  methods: {
    getValue: function(){
      if(this.picker){
        return document.getElementById(this.id).value;
      }

      if(this.id == 'phone'){
        var input = document.querySelector('#' + this.id);
        var iti = window.intlTelInputGlobals.getInstance(input);
        return iti.isValidNumber() ? iti.getNumber(intlTelInputUtils.numberFormat.E164) : '';
        
      }

      return this.value;
    }
  },
  mounted: function(){
    
    if(this.picker == 'datepicker'){

      var minDate = new Date();
      var explodedMinDate = this.minDate ? this.minDate.split('-') : [];
      if(explodedMinDate.length == 3){
        minDate.setFullYear(explodedMinDate[0]);
        minDate.setDate(explodedMinDate[2]);
        minDate.setMonth(parseInt(explodedMinDate[1]) - 1);
      }

      var elems = document.getElementById(this.id);
      var yearRange = 1;
      var options = {
        autoclose: true,
        //format: 'dd mmmm yyyy',
        format: 'yyyy-mm-dd',
        firstDay: 1, // 0=Sunday, 1=Monday
        minDate: minDate, //this.minDate ?? new Date(),
        defaultDate: minDate,
        maxDate: new Date(Date.now() - (-1000*60*60*24*365*yearRange)),
        yearRange: [new Date().getFullYear(), new Date().getFullYear() - (-yearRange)],
        showDaysInNextAndPreviousMonths: false,
        showClearBtn: false,
        i18n: {
          cancel: t('Annuler'),
          clear: t('Effacer'),
          done: t('OK'),
          months: [
            t('Janvier'),
            t('Février'),
            t('Mars'),
            t('Avril'),
            t('Mai'),
            t('Juin'),
            t('Juillet'),
            t('Août'),
            t('Septembre'),
            t('Octobre'),
            t('Novembre'),
            t('Décembre')
          ],
          monthsShort: [
            t('Jan.'),
            t('Fév.'),
            t('Mars'),
            t('Avril'),
            t('Mai'),
            t('Juin'),
            t('Juil.'),
            t('Août'),
            t('Sep.'),
            t('Oct.'),
            t('Nov.'),
            t('Déc.')
          ],
          weekdays: [
            t('Dimanche'),
            t('Lundi'),
            t('Mardi'),
            t('Mercredi'),
            t('Jeudi'),
            t('Vendredi'),
            t('Samedi')
          ],
          weekdaysShort: [
            t('Dim'),
            t('Lun'),
            t('Mar'),
            t('Mer'),
            t('Jeu'),
            t('Ven'),
            t('Sam')
          ],
          weekdaysAbbrev: [
            t('D'),
            t('L'),
            t('M'),
            t('M'),
            t('J'),
            t('V'),
            t('S')
          ]
        },
      };
      var instances = M.Datepicker.init(elems, options);
    }

    if(this.picker == 'timepicker'){
      var elems = document.getElementById(this.id);
      var options = {
        autoclose: true,
        twelveHour: false,
        i18n: {
          cancel: t('Annuler'),
          clear: t('Effacer'),
          done: t('OK')
        },
      };
      var instances = M.Timepicker.init(elems, options);
    }

    if(this.id == 'phone'){
      var elem = document.getElementById(this.id);
      var iti = intlTelInput(elem, {
        utilsScript: "/themes/custom/nktaxi/dist/js/intlTelInput-utils.js",
        initialCountry: document.documentElement.lang == 'fr' ? 'fr' : 'gb'
      });

      ['focusout','countrychange'].forEach(function(item){
        elem.addEventListener(item, function(e){
          if(iti.isValidNumber()){
            e.target.classList.add('valid');
            e.target.classList.remove('invalid');
            e.target.value = iti.getNumber(intlTelInputUtils.numberFormat.E164);
          }else{
            e.target.classList.remove('valid');
            e.target.classList.add('invalid');
          }
  
        });
      });
      

      var _this = this;
      elem.addEventListener('countrychange', function(e){
        _this.$emit('input-changed',e.target.value,this.id);
      });

      var input_field = elem.parentNode.parentNode;
      var i = input_field.querySelector('i');
      var label = input_field.querySelector('label');
      elem.parentNode.prepend(i);
      elem.parentNode.append(label);
      elem.parentNode.classList.add('input-field');

    }

  },
  template: `
<div class="input-field">
  <i class="material-icons prefix" v-if="icon">{{icon}}</i>
  <input
    v-bind:id="id"
    v-bind:type="type"
    class="validate"
    :class="picker"
    v-model="value"
    v-on:change="$emit('input-changed',getValue(),id)"
    v-on:keyup="$emit('input-changed',getValue(),id)"
  >
  <label v-bind:for="id"><slot></slot> <em v-if="required">({{ labels.requis }})</em></label>
  <span v-if="description" class="helper-text" data-error="erreur" data-success="Ok">{{ description }}</span>
</div>`
});
/*
 *  <choix-item items="[{label: 'Un', value: '1', icon: {value: 'call_made', position: 'right'}}]" v-on:item-choisi="foo"></choix-item>
 */
Vue.component('choix-item', {
  props: {
    items: Array,
    label: String,
    labelnotice: String,
    size: String
  },
  template: `
<div class="center-align">
  <h5 v-if='label'>{{ label }}</h5>
  <p v-if='labelnotice'><em v-html="labelnotice"></em></p>
  <bouton v-bind:size="size" v-for="(item, index) in items" v-on:click="$emit('item-choisi', item.value)" :key="'item-' + index">
    <i class="material-icons" :class="item.icon.position" v-if="item.icon">{{ item.icon.value }}</i>
    {{ item.label }}
  </bouton>
</div>`
});
/*
 *  <materialize-select items="[{label: 'Un', value: '1'}]" label="Label" v-on:item-choisi="foo"></materialize-select>
 */
Vue.component('materialize-select', {
  props: {
    id: String,
    items: Array,
    label: String,
    icon: String
  },
  mounted: function(){
    var elems = document.getElementById(this.id);
    var options = {};
    var instances = M.FormSelect.init(elems, options);
  },
  methods: {
    change: function(e){
      //console.log(e,e.value,e.target.value);
      this.$emit('item-choisi', e.target.value);
    }
  },
  template: `
<div class="input-field">
  <i class="material-icons prefix" v-if="icon">{{icon}}</i>
  <select v-bind:id="id" v-on:change="change">
    <option value="" disabled selected>{{ label }}</option>
    <option v-for="(item, index) in items" :value="item.value" :key="'item-' + index">{{ item.label }}</option>
  </select>
  <label v-if='label'>{{ label }}</label>
</div>`
});


// MOLECULES

/*
 *  <choix-vallee @place-choisie="foo"></choix-vallee>
 */
Vue.component('choix-vallee', {
  props: {},
  data: function(){
    return {
      place: {
        ville: '',
        type: '',
        complement: {}
      },
      types: [
        {
          label: t('Avion'),
          value: 'avion',
          icon: {
            value: 'flight_takeoff',
            position: 'right'
          }
        },
        {
          label: t('Train'),
          value: 'train',
          icon: {
            value: 'train',
            position: 'right'
          }
        },
        {
          label: t('Autre'),
          value: 'autre',
          icon: {
            value: 'location_searching',
            position: 'right'
          }
        },
      ],
      tempNum: '',
      tempAdresse: {
        hotel: '',
        rue: '',
        complement: '',
        cp: '',
        ville: ''
      },
    };
  },
  computed: {
    labels: function(){
      return {
        titre: t('Dans quelle ville ?'),
        numero: this.place.type=='avion' ? t('Numéro de vol') : t('Numéro de train'),
        numeroBouton: this.tempNum=='' ? t('Ignorer') : t('Suivant'),
        type: this.place.type=='avion' ? t('Avion') : ( this.place.type=='train' ? t('Train') : t('Autre') ),
        adresse: {
          hotel: t('Hôtel/Résidence'),
          titre: t('Adresse'),
          rue: t('Rue'),
          complement: t('Complément d\'adresse'),
          cp: t('Code postal'),
          ville: t('Ville'),
          boutonText: t('Suivant')
        }
      };
    },
    villes: function(){
      var villes = [];
      if(this.place.type=='avion'){
        places.aeroports.forEach(function(item){
          villes.push({
            label: item.nom,
            value: item.code
          });
        });
      }
      if(this.place.type=='train'){
        places.gares.forEach(function(item){
          villes.push({
            label: item.nom,
            value: item.code
          });
        });
      }

      return villes;
    },
    numeroIcon: function(){
      return this.place.type=='avion' ? 'local_airport' : 'train';
    },
    numeroButtonSize: function(){
      return this.tempNum=='' ? 'flat' : 'small';
    },
    showChampType: function(){
      return this.place.type == '';
    },
    showChampVille: function(){
      return (this.place.type=='avion' || this.place.type=='train') && this.place.ville=='' && !this.showChampType;
    },
    showChampNumero: function(){
      return (this.place.type=='avion' || this.place.type=='train') && !this.showChampVille && !this.showChampType;
    },
    showChampAdresse: function(){
      return this.place.type=='autre' && Object.keys(this.place.complement.adresse).length === 0 && !this.showChampType;
    },
    adresseEstComplete: function(){
      return this.place.type == 'autre' &&
             this.tempAdresse.rue != '' &&
             this.tempAdresse.cp != '' &&
             this.tempAdresse.ville != '';
    }
  },
  methods: {
    setType: function(value){
      this.place.type = value;
      switch(value){
        case 'train':
        case 'avion':
          this.place.complement = {
            numero: ''
          };
          break;
        case 'autre':
        default:
          this.place.complement = {
            adresse: {}
          };
          break;
      }
    },
    resetType: function(){
      this.place.type = '';
      this.place.ville = '';
      this.place.complement = {};
    },
    setVille: function(value){
      this.place.ville = value;
    },
    resetVille: function(){
      this.place.ville = '';
      if(this.place.type == 'autre'){
        this.place.complement.adresse = {};
      }
    },
    setTempNumero: function(value){
      this.tempNum = value;
    },
    setNumero: function(){
      this.place.complement.numero = this.tempNum;
      this.emitPlaceChoisie();
    },
    setTempAdresseHotel: function(value){
      this.tempAdresse.hotel = value;
    },
    setTempAdresseRue: function(value){
      this.tempAdresse.rue = value;
    },
    setTempAdresseComplement: function(value){
      this.tempAdresse.complement = value;
    },
    setTempAdresseCP: function(value){
      this.tempAdresse.cp = value;
    },
    setTempAdresseVille: function(value){
      this.tempAdresse.ville = value;
    },
    setAdresse: function(value){
      this.place.ville = this.tempAdresse.ville;
      this.place.complement.adresse = this.tempAdresse;
      this.emitPlaceChoisie();
    },
    getVilleByCode: function(code){
      return getVilleByCode(code);
    },
    emitPlaceChoisie: function(){
      this.$emit('place-choisie', this.place);
    }
  },
  template: '#choix-vallee'
});
/*
 *  <choix-station @place-choisie="foo"></choix-station>
 */
Vue.component('choix-station', {
  props: {
    sens: {
      type: String,
      default: 'sv'
    },
    transport: {
      type: String,
      default: 'other'
    }
  },
  data: function(){
    return {
      place: {
        ville: '',
        type: 'station',
        complement: {
          residence: ''
        }
      },
      tempResidence: '',
      tempAdresse: {
        hotel: '',
        rue: '',
        complement: '',
        cp: '',
        ville: ''
      }
    };
  },
  computed: {
    labels: function(){
      return {
        titre: t('Dans quelle station ?'),
        titreSecteurs: t('Dans quel secteur ?'),
        titreResidence: t('Où séjournerez-vous ?'),
        residence: t('Hôtel/Résidence'),
        residenceBouton: this.tempResidence=='' ? t('Ignorer') : t('Suivant'),
        adresse: {
          hotel: t('Hôtel/Résidence'),
          titre: t('Adresse'),
          rue: t('Rue'),
          complement: t('Complément d\'adresse'),
          cp: t('Code postal'),
          ville: t('Ville'),
          boutonText: t('Suivant')
        }
      };
    },
    stations: function(){
      var stations = [];
      places.stations.forEach(function(item){
        stations.push({
          label: item.nom,
          value: item.code
        });
      });

      // Add "Autre" destination
      if(
        ( this.sens == "vs" && (this.transport == "train" || this.transport == "avion") )
        ||
        ( this.sens == "sv" )
      ){
        stations.push({
          label: t('Autre'),
          value: 'other'
        });
      }

      return stations;
    },
    secteurs: function(){
      // Retourne la liste des sous-secteurs de la station choisie
      var secteurs = [];
      var _this = this;
      places.stations.forEach(function(item){
        if(item.code == _this.place.ville && item.secteurs){
          item.secteurs.forEach(function(secteur){
            secteurs.push({
              label: secteur.nom,
              value: secteur.code
            });
          });
        }
      });
      return secteurs;
    },
    residenceBoutonSize: function(){
      return this.tempResidence == '' ? 'flat' : 'small';
    },
    showChampStation: function(){
      return this.place.ville == '';
    },
    showChampSecteurs: function(){
      return /* this.place.type == 'station' &&  */this.secteurs.length > 0;
    },
    showChampResidence: function(){
      return this.place.complement.residence == '' &&
             !this.showChampSecteurs &&
             !this.showChampStation;
    },
    showChampAdresse: function(){
      return this.place.ville == 'other' &&
             /* Object.keys(this.place.complement.adresse).length === 0 && */
             !this.showChampSecteurs &&
             !this.showChampStation;
    },
    adresseEstComplete: function(){
      return this.place.ville == 'other' &&
             this.tempAdresse.rue != '' &&
             this.tempAdresse.cp != '' &&
             this.tempAdresse.ville != '';
    },
  },
  methods: {
    setStation: function(value){
      this.place.ville = value;

      if(value == 'other'){
        //this.place.ville = 'other';
        this.place.complement = {
          adresse: {}
        };
      }else{
        //this.place.type = 'station';
        this.place.complement = {
          residence: ''
        };
      }
    },
    resetStation: function(){
      this.place.ville = '';
      //this.place.type = 'station';
      this.place.complement = {
        residence: ''
      };
    },
    setSecteur: function(value){
      this.place.ville = value;
    },
    setTempResidence: function(value){
      this.tempResidence = value;
    },
    setResidence: function(){
      this.place.complement.residence = this.tempResidence!='' ? this.tempResidence : ' ';
      this.emitPlaceChoisie();
    },
    setTempAdresseHotel: function(value){
      this.tempAdresse.hotel = value;
    },
    setTempAdresseRue: function(value){
      this.tempAdresse.rue = value;
    },
    setTempAdresseComplement: function(value){
      this.tempAdresse.complement = value;
    },
    setTempAdresseCP: function(value){
      this.tempAdresse.cp = value;
    },
    setTempAdresseVille: function(value){
      this.tempAdresse.ville = value;
    },
    setAdresse: function(){
      this.place.ville = this.tempAdresse.ville;
      this.place.complement.adresse = this.tempAdresse;
      this.emitPlaceChoisie();
    },
    getVilleByCode: function(code){
      return getVilleByCode(code);
    },
    emitPlaceChoisie: function(){
      this.$emit('place-choisie', this.place);
    }
  },
  template: '#choix-station'
});


// ORGANISMS

/*
 *  <course :initialCourse="course" @course-definie="foo"></course>
 */
Vue.component('course', {
  props: {
    initialCourse: {
      type: Object,
      // Object or array defaults must be returned from
      // a factory function
      default: function () {
        return Object.assign({}, newCourse);
      }
    },
    minDate: {
      type: String,
      default: new Date()
    }
  },
  mounted: function(){
    // prepare hours
    for(i=0 ; i<24 ; i++){
      i = i<10 ? '0'+i : i;
      this.hours.push({label: i, value: i});
    }

    // prepare minutes
    for(i=0 ; i<60 ; i++){
      i = i<10 ? '0'+i : i;
      this.minutes.push({label: i, value: i});
    }

  },
  data: function(){
    return {
      course: this.initialCourse,
      tempSens: this.initialCourse.sens,
      sensItems: [
        {
          label: t('Une arrivée'),
          value: 'vs',
          icon: {
            value: 'call_made',
            position: 'right'
          }
        },
        {
          label: t('Un départ'),
          value: 'sv',
          icon: {
            value: 'call_received',
            position: 'right'
          }
        }
      ],
      passagerCountItems: [
        {
          label: '1',
          value: '1'
        },
        {
          label: '2',
          value: '2'
        },
        {
          label: '3',
          value: '3'
        },
        {
          label: '4',
          value: '4'
        },
        {
          label: '5',
          value: '5'
        },
        {
          label: '6',
          value: '6'
        },
        {
          label: '7',
          value: '7'
        },
        {
          label: '8',
          value: '8'
        },
      ],
      bagagesCountItems: [
        {
          label: '0',
          value: '0'
        },
        {
          label: '1',
          value: '1'
        },
        {
          label: '2',
          value: '2'
        },
        {
          label: '3',
          value: '3'
        },
        {
          label: '4',
          value: '4'
        },
        {
          label: '5+',
          value: '5'
        },
      ],
      skiChoices: [
        {
          label: t('Oui'),
          value: 'oui'
        },
        {
          label: t('Non'),
          value: 'non'
        }
      ],
      skisCountItems: [
        {
          label: '1',
          value: '1'
        },
        {
          label: '2',
          value: '2'
        },
        {
          label: '3',
          value: '3'
        },
        {
          label: '4',
          value: '4'
        },
        {
          label: '5+',
          value: '5'
        },
      ],
      prestationChoices: [
        {
          label: t('NK Basic'),
          value: 'basic'
        },
        {
          label: t('NK Luxury'),
          value: 'luxury'
        }
      ],
      hours: [],
      minutes: [],
      temp_hour: '',
      temp_minute: '',
      temp_show_prestation: false
    };
  },
  computed: {
    labels: function(){
      return {
        destination: t('Votre demande de transfert concerne ...'),
        destinationNotice: t('Vous pourrez ajouter un retour une fois votre arrivée renseignée.'),
        nbrPassagers: t('Combien de passagers ?'),
        nbrPassagersNotice: t('Plus de 8 passagers ?  Envoyez-nous votre demande <a href="/fr/contact">ici</a>.'),
        nbrBagages: t('Combien de bagages ?'),
        skis: t('Aurez-vous des skis à transporter ?'),
        nbrSkis: t('Combien de paires de skis ?'),
        dateTitre: t('A quelle date souhaitez-vous partir ?'),
        date: t('Date'),
        heure: t('Heure'),
        pickup: t('Lieu de prise en charge'),
        dropoff: t('Lieu de dépose'),
        tarif: t('Tarif :'),
        duree: t('Durée :'),
        valider: t('Suivant'),
        heure: t('Heure'),
        minute: t('Min'),
        prestation: t('Prestation'),
        notAvailable: t('Non disponible'),
        max7Passagers: t('(7 passagers max)'),
        nkBasicInfos: t('Pas de choix de véhicule'),
        nkLuxuryInfos: t('Mercedes Classe-V Avantgarde XL'),
        choixPrestation: t('Sélectionner la prestation souhaitée'),
        voirVehicules: t('<a href="/fr/vehicule" target="_blank">Découvrir les véhicules</a>'),
        //titre: store.state.reservation.trajets.length == 1 ? t('Votre trajet') : ( this.trajetIndex == 0 ? t('Votre trajet Aller') : t('Votre trajet Retour') )
        summaryNotice: this.showBouton ? t('Vérifiez vos critères avant de continuer.') : '',
        summarySubNotice: this.showBouton ? t('Vous pouvez les modifier en cliquant sur la croix située à côté.') : '',
        askForQuote: t('Demandez votre devis'),
        autoroute: t('Tout autoroute'),
        trajet_tout_autoroute: t('TRAJET TOUT AUTOROUTE'),
        tarif_plus_details: t("Trajet normal par le Lac d'Annecy"),
        tarif_plus_motorway_details: t('Trajet confort tout autoroute par Chambéry'),
      };
    },
    showSens: function(){
      return this.course.sens=='';
    },
    showStation: function(){
      this.temp_show_prestation = false;
      return (this.course.sens == 'sv' && this.course.pickup.ville == '') || (this.course.sens == 'vs' && this.course.pickup.ville != '' && this.course.dropoff.ville == '');
    },
    showVallee: function(){
      this.temp_show_prestation = false;
      return (this.course.sens == 'vs' && this.course.pickup.ville == '') || (this.course.sens == 'sv' && this.course.pickup.ville != '' && this.course.dropoff.ville == '');
    },
    showDate: function(){
      //return this.course.date=='' && !this.showBagages && !this.showPassagers && !this.showSens && !this.showStation && !this.showVallee;
      return this.course.date=='' && !this.showSens && !this.showStation && !this.showVallee;
    },
    showHeure: function(){
      //return this.course.heure=='' && !this.showDate && !this.showBagages && !this.showPassagers && !this.showSens && !this.showStation && !this.showVallee;
      return this.course.heure=='' && !this.showDate && !this.showSens && !this.showStation && !this.showVallee;
    },
    showPassagers: function(){
      return this.course.nbrPassagers==0 && !this.showHeure && !this.showDate && !this.showSens && !this.showStation && !this.showVallee;
    },
    showBagages: function(){
      //return this.course.nbrBagages<0 && !this.showPassagers && !this.showSens && !this.showStation && !this.showVallee;
      return false;
    },
    showSkis: function(){
      let skiOptionsNotFullfilled = this.course.skis=='';
      skiOptionsNotFullfilled = this.course.skis=='oui' && this.course.nbrSkis < 0 ? true : skiOptionsNotFullfilled;

      return skiOptionsNotFullfilled && !this.showPassagers && !this.showHeure && !this.showDate && !this.showSens && !this.showStation && !this.showVallee;
    },
    showPrestation: function(){
      this.temp_show_prestation = false;

      let showPrest = this.course.prestation=='' && !this.showSkis && !this.showPassagers && !this.showHeure && !this.showDate && !this.showSens && !this.showStation && !this.showVallee;
      
      if(showPrest){
          
        var req = '&resa='+prepareRequest(this.course,0);
        //if(index==1) req+= '&aller='+prepareRequest(_this.reservation.trajets[0],0);

        let _this = this;
        axios
          .get('/nk-api?endpoint=getTarifByPrestation'+req)
          .then(function(response){
            if(typeof response.data.tarif_basic !== 'undefined') _this.course.tarif_basic = response.data.tarif_basic;
            if(typeof response.data.tarif_luxury !== 'undefined') _this.course.tarif_luxury = response.data.tarif_luxury;
            if(typeof response.data.tarif_basic_plus !== 'undefined') _this.course.tarif_basic_plus = response.data.tarif_basic_plus;
            if(typeof response.data.tarif_luxury_plus !== 'undefined') _this.course.tarif_luxury_plus = response.data.tarif_luxury_plus;
            _this.temp_show_prestation = true;
          });

      }else{
        
      }

      return showPrest;
    },
    showBouton: function(){
      //return !this.showHeure && !this.showDate && !this.showBagages && !this.showPassagers && !this.showSens && !this.showStation && !this.showVallee;
      return !this.showPrestation && !this.showHeure && !this.showDate && !this.showSkis && !this.showPassagers && !this.showSens && !this.showStation && !this.showVallee;
    },
    tarifs: function(){
      return {
        basic: this.course.tarif_basic,
        luxury: this.course.tarif_luxury,
      }
    },
  },
  methods: {
    getSens: function(){
      switch(this.course.sens){
        case 'sv':
          return t('Un départ');
          break;
        case 'vs':
          return t('Une arrivée');
          break;
        default:
          return t('Non défini');
          break;
      }
    },
    getPickup: function(){
      var text = t('Départ :') + ' ';
      var ville = getVilleByCode(this.course.pickup.ville);
      if(this.course.pickup.type == 'avion') text+= t('Aéroport de %ville').replace('%ville',ville);
      else if(this.course.pickup.type == 'train') text+= t('Gare de %ville').replace('%ville',ville);
      else text+=ville;
      return text;
    },
    getDropoff: function(){
      var text = t('Arrivée :') + ' ';
      var ville = getVilleByCode(this.course.dropoff.ville);
      if(this.course.dropoff.type == 'avion') text+= t('Aéroport de %ville').replace('%ville',ville);
      else if(this.course.dropoff.type == 'train') text+= t('Gare de %ville').replace('%ville',ville);
      else text+=ville;
      return text;
    },
    getNbrPassagersTexte: function(){
      if(this.course.nbrPassagers > 1){
        return this.course.nbrPassagers + ' ' + t('personnes');
      }else{
        return this.course.nbrPassagers + ' ' + t('personne');
      }
    },
    getNbrBagagesTexte: function(){
      return getNbrBagagesTexte(this.course.nbrBagages);
    },
    getSkisTexte: function(){
      return getSkisTexte(this.course.skis, this.course.nbrSkis);
    },
    getPrestationTexte: function(){
      return getPrestationTexte(this.course.prestation);
    },
    getDateTexte: function(){
      switch(this.course.pickup.type+'-'+this.course.dropoff.type){
        case 'station-autre':
        case 'station-avion':
        case 'station-train':
        default:
          return t('A quelle date souhaitez-vous partir ?');
        case 'autre-station':
        case 'avion-station':
        case 'train-station':
          return t('A quelle date arrivez-vous ?');
      }
      
    },
    getHeureTexte: function(){
      switch(this.course.pickup.type+'-'+this.course.dropoff.type){
        case 'autre-station':
        case 'station-autre':
        default:
          return t('À quelle heure souhaitez-vous être pris en charge ?');
          break;
        case 'avion-station':
          return t('À quelle heure arrive votre vol ?');
          break;
        case 'train-station':
          return t('À quelle heure arrive votre train ?');
          break;
        case 'station-avion':
          return t('À quelle heure part votre vol ?');
          break;
        case 'station-train':
          return t('À quelle heure part votre train ?');
          break;
      }
    },
    setSens: function(value){
      this.course.sens = value=='vs'?'vs':'sv';

      if(this.tempSens!=value){
        var oldPickup = this.course.pickup;
        this.course.pickup = this.course.dropoff;
        this.course.dropoff = oldPickup;
        this.tempSens = value;
      }
    },
    setPlace: function(value){
      if(this.course.pickup.ville == ''){
        this.setPickupPlace(value);
      }else{
        this.setDropoffPlace(value);
      }
    },
    setStation: function(value){
      if(this.course.sens == 'sv'){
        this.course.pickup = value;
      }else{
        this.course.dropoff = value;
      }
    },
    setVallee: function(value){
      if(this.course.sens == 'vs'){
        this.course.pickup = value;
      }else{
        this.course.dropoff = value;
      }
    },
    setNombrePassagers: function(value){

      // Remove prestation if there is more than 7 passengers
      if(value == 8 && this.course.prestation == 'luxury'){
        this.course.prestation = ''; 
      }

      this.course.nbrPassagers = value;
    },
    setNombreBagages: function(value){
      this.course.nbrBagages = value;
    },
    setSkis: function(value){
      this.course.skis = value;
    },
    setNombreSkis: function(value){
      this.course.nbrSkis = value;
    },
    setPrestation: function(value){

      // Prevent setting "prestation" for luxury if we have 8 passengers
      if((value == 'luxury' || value == 'luxury_plus') && this.course.nbrPassagers == 8) return;

      if(this.course.autoroute){
        this.course.autoroute = null;
      }

      if(value == 'basic_plus'){
        this.course.prestation = 'basic';
        this.course.autoroute = true;
      }
      else if(value == 'luxury_plus'){
        this.course.prestation = 'luxury';
        this.course.autoroute = true;
      }
      else{
        this.course.prestation = value;
      }
      console.log(this.course);
    },
    setDate: function(value){
      this.course.date = value;
    },
    setTime: function(){
      if(this.temp_hour != '' && this.temp_minute != ''){
        this.course.heure = this.temp_hour + ':' + this.temp_minute;
      }
    },
    setHeureAndMinutes: function(value){
      // Is it a valid format HH:MM ?
      let split = value.includes('h') ? value.split('h') : value.split(':');
      if(split.length == 2 && 
        !isNaN(split[0]) && split[0] >= 0 && split[0] < 24 && 
        !isNaN(split[1]) && split[1] >= 0 && split[1] < 60
      ){
        this.course.heure = value;
      }
    },
    setHeure: function(value){
      this.temp_hour = value;
    },
    setMinute: function(value){
      this.temp_minute = value;
    },
    resetSens: function(){
      this.course.sens = newCourse.sens;
    },
    resetNbrPassagers: function(){
      this.course.nbrPassagers = newCourse.nbrPassagers;
    },
    resetNbrBagages: function(){
      this.course.nbrBagages = newCourse.nbrBagages;
    },
    resetSkis: function(){
      this.course.skis = newCourse.skis;
      this.course.nbrSkis = newCourse.nbrSkis;
    },
    resetDate: function(){
      this.course.date = newCourse.date;
    },
    resetHeure: function(){
      this.course.heure = newCourse.heure;
    },
    resetPickup: function(){
      this.course.pickup = newCourse.pickup;
    },
    resetDropoff: function(){
      this.course.dropoff = newCourse.dropoff;
    },
    resetPrestation: function(){
      this.course.prestation = newCourse.prestation;
    },
    emitCourseDefinie: function(){
      this.$emit('course-definie',this.course);
    },
    tarif_basic: function(){
      return this.course.tarif_basic;
    }
  },
  template: '#course'
});

/*
 *  <coordonnees @update="foo"></coordonnees>
 */
Vue.component('coordonnees', {
  data: function(){
    return {
      fields: [
        {
          id: 'nom',
          icon: 'person',
          required: true,
          label: t('Nom'),
        },
        {
          id: 'prenom',
          icon: 'person',
          required: true,
          label: t('Prénom'),
        },
        {
          id: 'email',
          icon: 'mail',
          required: true,
          type: 'email',
          label: t('Email'),
        },
        {
          id: 'phone',
          icon: 'phone_iphone',
          required: true,
          label: t('Téléphone'),
        },
      ],
      coordonnees: {
        nom: '',
        prenom: '',
        email: '',
        phone: ''
      },
    };
  },
  computed: {
    labels: function(){
      return {
        titre: t('Entrez vos coordonnées pour complèter votre demande de réservation'),
        next: t('Suivant')
      };
    },
    showBoutonNext: function(){
      var coordonnees = this.coordonnees;
      return coordonnees.nom!='' && coordonnees.prenom != '' && coordonnees.email!='' && coordonnees.phone!='';
    }
  },
  methods: {
    setValue: function(id, value){
      switch(id){
        case 'nom':
          this.coordonnees.nom = value;
          break;
        case 'prenom':
          this.coordonnees.prenom = value;
          break;
        case 'email':
          // Validate email format
          var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          this.coordonnees.email = re.test(value) ? value : '';
          break;
        case 'phone':
          this.coordonnees.phone = value;
          break;
      }

      this.$emit('update',this.coordonnees);

    },
    getValue: function(id){
      switch(id){
        case 'nom':
          return this.coordonnees.nom;
          break;
        case 'prenom':
          return this.coordonnees.prenom;
          break;
        case 'email':
          return this.coordonnees.email;
          break;
        case 'phone':
          return this.coordonnees.phone;
          break;
        default:
          return '';
          break;
      }
    },
    validate: function(){
      this.$emit('validate');
    }
  },
  template: '#coordonnees'
});

/*
 *  <message @update="foo"></message>
 */
Vue.component('message', {
  data: function(){
    return {
      message: ''
    };
  },
  computed: {
    labels: function(){
      return {
        titre: t('Voulez-vous ajouter un message ?'),
        placeholder: t('Enfants, prise en charge spécifique, etc.'),
        rgpd: t("En soumettant ce formulaire, j'autorise ce site à conserver les données personnelles transmises. Ces données seront utilisées uniquement dans le cadre du traitement de cette demande de réservation. Aucune exploitation commerciale ne sera faite de ces données. Voir notre politique de confidentialité."),
        submit: t('Envoyer la demande de réservation')
      };
    },

  },
  methods: {
    emitUpdate: function(id, value){
      this.$emit('update',this.message);
    }
  },
  template: '#message'
});

/*
 *  <infos :reservation="reservation"></infos>
 */
Vue.component('infos', {
  props:{
    reservation: Object
  },
  computed: {
    labels: function(){
      return {
        pickup: t('Prise en charge :'),
        dropoff: t('Dépose :'),
        date: t('Date :'),
        prix: t('Estimation :'),
        prix_conditions: t('Sous réserve de modification'),
        reduction: t('du prix total aller et retour remis sur le retour'),
        prestation: t('Prestation'),
        autoroute: t('Tout autoroute'),
      };
    }
  },
  methods: {
    getVilleByCode: function(code){
      return getVilleByCode(code);
    },
    getLocation: function(trajet){
      var ville = getVilleByCode(trajet.ville);
      var ret = '';

      switch(trajet.type){
        case 'avion':
          ret = t('Aéroport de %ville').replace('%ville',ville);
          if(trajet.complement.numero!=''){
            ret+= '<br>Vol n° ' + trajet.complement.numero;
          }
          break;
        case 'train':
          ret = t('Gare de %ville').replace('%ville',ville);
          if(trajet.complement.numero!=''){
            ret+= '<br>Train n° ' + trajet.complement.numero;
          }
          break;
        case 'station':
          if(trajet.complement.adresse){
            ret+= (trajet.complement.adresse.hotel!='') ? trajet.complement.adresse.hotel+'<br>' : '';
            ret+= trajet.complement.adresse.rue+'<br>';
            if(trajet.complement.adresse.complement!='') ret+= trajet.complement.adresse.complement+'<br>';
            ret+= trajet.complement.adresse.cp+' '+trajet.complement.adresse.ville;
          }else{
            ret = ville;
            if(trajet.complement.residence!=''){
              ret+= '<br>' + trajet.complement.residence;
            }
          }
          break;
        case 'autre':
          ret = (trajet.complement.adresse.hotel!='') ? trajet.complement.adresse.hotel+'<br>' : '';
          ret+= trajet.complement.adresse.rue+'<br>';
          if(trajet.complement.adresse.complement!='') ret+= trajet.complement.adresse.complement+'<br>';
          ret+= trajet.complement.adresse.cp+' '+trajet.complement.adresse.ville;
          break;
        default:
          ret = ville;
          break;
      }

      return ret;
    },
    getCourseStatus: function(course){
      return getCourseStatus(course);
    },
    getTrajetTitle: function(trajet){
      if(this.reservation.trajets.length > 1){
        return (this.reservation.trajets[0] == trajet) ? t('Votre trajet aller') : t('Votre trajet retour');
        
      }else{
        if(trajet.sens == ''){
          return t('Entrez vos informations pour obtenir une estimation et envoyer une demande de réservation');
        }else{
          return t('Votre trajet');
        }
        
      }
    },
    getDate: function(date){
      return date;
    },
    getNbrBagagesTexte: function(count){
      return getNbrBagagesTexte(count);
    },
    getSkisTexte: function(value, count=0){
      return getSkisTexte(value, count);
    },
    getNbrPassagersTexte: function(count){
      return count<2 ? t('%count personne').replace('%count',count) : t('%count personnes').replace('%count',count);
    },
    getHeureTexte: function(index){
      switch(this.reservation.trajets[index].pickup.type+'-'+this.reservation.trajets[index].dropoff.type){
        case 'autre-station':
        case 'station-autre':
        default:
          return t('Heure de prise en charge :');
        case 'avion-station':
          return t('Heure d\'arrivée du vol :');
        case 'train-station':
          return t('Heure d\'arrivée du train :');
        case 'station-avion':
          return t('Heure de départ du vol :');
        case 'station-train':
          return t('Heure de départ du train :');
      }
    },
    getPriceWithReduction: function(price, reduction){
      return price * ( 100 - reduction ) / 100;
    },
    getPrestationTexte: function(value){
      return getPrestationTexte(value);
    },
  },
  template: '#infos'
});

/*
 *  <reservation></reservation>
 */
Vue.component('reservation', {
  props: {},
  data: function(){
    return {
      reservation: {
        trajets: [],
        coordonnees: {
          nom: '',
          prenom: '',
          email: '',
          phone: ''
        },
        message: ''
      },
      state: 'step1'
      //reservationEnvoyee: false,
      //reservationConfirmee: false
    };
  },
  mounted: function(){
    var c = Object.assign({}, newCourse);
    //c.sens = 'sv';
    this.reservation.trajets.push(c);
  },
  computed: {
    labels: function(){
      return {
        valider: t('Envoyer'),
        envoyee: t('Demande de réservation en cours d\'envoi...'),
        confirmee: t('Demande de réservation envoyée'),
        notice: t('Nous vous contacterons au plus vite pour confirmer cette réservation.'),
        addBack: t('Ajouter le trajet retour ?'),
        oui: t('Oui'),
        non: t('Non'),
        back: t('Retour'),
        //reduction: t("Bénéficiez de 5% de réduction sur votre trajet aller/retour, offre valable pour toute réservation hors haute saison d'hiver (vacances de Noël et de mi-Février à mi-Mars). Remise appliquée sur le trajet retour.")
        reduction: ""
      };
    },
    showTrajets: function(){
      return this.state == 'step1' || this.state == 'step2' || this.state == 'step3';
    },
    showCoordonnees: function(){
      return this.state == 'coordonnees';
    },
    showMessage: function(){
      return this.state == 'message';
    },
    showBackButton: function(){
      return this.state == 'step2' || this.state == 'step3' || this.state == 'coordonnees' || this.state == 'message';
    }
  },
  methods: {
    setTrajet: function(value){
      if(this.state == 'step1'){
        this.state = 'step2';
      }else{
        this.state = 'coordonnees';
      }

      this.updatePrixEtDuree();
    },
    setCoordonnees: function(value){
      this.reservation.coordonnees = value;
    },
    goToMessage: function(){
      this.state = 'message';
    },
    setMessage: function(value){
      this.reservation.message = value;
      this.sendReservation();
    },
    ajouteTrajetRetour: function(value){
      if(value == 'oui'){
        if(this.reservation.trajets.length < 2){
          var c = Object.assign({}, newCourse);
          //c.sens = 'sv';
          c.sens = this.reservation.trajets[0].sens=='sv' ? 'vs' : 'sv';
          c.pickup = this.reservation.trajets[0].dropoff;
          c.dropoff = this.reservation.trajets[0].pickup;
          c.nbrBagages = this.reservation.trajets[0].nbrBagages;
          c.nbrPassagers = this.reservation.trajets[0].nbrPassagers;
          c.skis = this.reservation.trajets[0].skis;
          c.nbrSkis = this.reservation.trajets[0].nbrSkis;
          c.prestation = this.reservation.trajets[0].prestation;
          c.autoroute = this.reservation.trajets[0].autoroute;
          this.reservation.trajets.push(c);
        }
        this.state = 'step3';
      }else{
        if(this.reservation.trajets[1]){
          this.reservation.trajets.splice(1,1);
        }
        this.state = 'coordonnees';
      }
    },
    sendReservation: function(){
      var _this = this;

      this.reservation.langcode = document.documentElement.getAttribute('lang');

      axios
        .post('/nk-api?endpoint=postResa',this.reservation)
        .then(function(response){
          let res = response.data;
          if(res.erreur){
            let last_error = '';
            Object.keys(res.erreur).forEach(key => {
              alert(key + ': ' +res.erreur[key]);
              last_error = key;
            });

            switch(last_error){
              case 'email':
                _this.state = 'coordonnees';
                break;
              default:
                _this.state = 'message';
                break;
            }
            
          }else{
            _this.state = 'sent';
          }
        });

      this.state = 'sending';
    },
    updatePrixEtDuree: function(){
      var _this = this;

      this.reservation.trajets.forEach(function(trajet,index){
        
        var req = '&resa='+prepareFullRequest(trajet,index);
        if(index==1) req+= '&aller='+prepareFullRequest(_this.reservation.trajets[0],0);

        
        // Hack "tout autoroute" pour Genève
        if(trajet.autoroute){
          req = req.replace('V9', 'V10').replace('V9', 'V10'); 
        }

        axios
          .get('/nk-api?endpoint=getTarif'+req)
          .then(function(response){
            if(typeof response.data.tarif !== 'undefined') _this.reservation.trajets[index].tarif = response.data.tarif;
            if(typeof response.data.tarif_calculated !== 'undefined') _this.reservation.trajets[index].tarif_calculated = response.data.tarif_calculated;
            if(typeof response.data.duree !== 'undefined') _this.reservation.trajets[index].duree = response.data.duree;
            if(typeof response.data.reduction !== 'undefined') _this.reservation.trajets[index].reduction = response.data.reduction;
          });

      });


    },
    /*prepareRequest: function(trajet,index){
      var station = trajet.sens=='sv' ? trajet.pickup.ville : trajet.dropoff.ville;
      station = getTarifByCode(station);
      var vallee = trajet.sens=='vs' ? trajet.pickup.ville : trajet.dropoff.ville;
      vallee = getTarifByCode(vallee);
      var passagers = trajet.nbrPassagers;
      var date = trajet.date.replace('-','_').replace('-','_');
      var heure = trajet.heure.replace(':','_');
      var retour = index==0 ? 'to' : 'back';
      var sens = trajet.sens;
      var transport = trajet.sens=='vs' ? trajet.pickup.type : trajet.dropoff.type;

      var req = station+'-'+vallee+'-'+passagers+'-'+date+'-'+heure+'-'+retour+'-'+sens+'-'+transport;

      return req;
    },//*/
    goBack: function(){
      switch(this.state){
        case 'message':
          this.state = 'coordonnees';
          break;
        case 'coordonnees':
          this.state = this.reservation.trajets.length > 1 ? 'step3' : 'step2';
          break;
        case 'step3':
          this.state = 'step2';
          break;
        case 'step2':
          this.state = 'step1';
          break;
      }
    }
  },
  template: '#reservation'
});



/******************************/
/*       Vue App              */
/******************************/
var app = new Vue({
  el: '#app',
  data: {
    ready: false,
  },
  computed: { 
    labels: function(){
      return {
        loading: t('Chargement du formulaire...'),
      }
    }
  },
  methods: {
    test: function(value = 'none'){
      console.log('test',value);
    },
  },
  mounted: function(){
    var _this = this;
    axios
      .get('/nk-api?endpoint=getPlaces')
      .then(function(response){
        if(response.data.places){
          places = response.data.places;
          _this.ready = true;
        }else{
          message('Erreur du serveur')
        }
        //stroe.state.places =
      });
  },
});
